import React from 'react';
import { Script } from 'gatsby';

export const MiawChat = () => {
  const id = process.env.GATSBY_MIAW_CHAT_ID;
  const team = process.env.GATSBY_MIAW_CHAT_TEAM;
  const src = process.env.GATSBY_MIAW_CHAT_SRC;
  const scrt = process.env.GATSBY_MIAW_CHAT_SCRT;

  const enableMiaw = id && team && src && scrt;

  const initEmbeddedMessaging = () => {
    try {
      embeddedservice_bootstrap.settings.language = 'pt_BR';

      embeddedservice_bootstrap.init(id, team, src, {
        scrt2URL: scrt,
      });
    } catch (err) {
      console.error('Error loading Embedded Messaging: ', err);
    }
  };

  if (!enableMiaw) {
    return null;
  }

  return (
    <Script
      defer
      id="miaw-script"
      src={`${src}/assets/js/bootstrap.min.js`}
      data-testid="miaw-script"
      onLoad={() => initEmbeddedMessaging()}
    ></Script>
  );
};
